import React,{useState, useEffect, useRef} from 'react'
import authQueries from '../../queries/authQueries';
import { useFormContext } from '../../Context/FormContext';
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Spin, } from 'antd';

const OtpScreen = ({setCurrent, current, setCurrentTab, currentTab, navTab, setNavTab}) => {

    const [otps, setOtps] = useState({ 1: "", 2: "", 3: "", 4: "", 5: "", 6: "" });

    const [otp, setOtp] = useState(['', '', '', '', '', '']);

    const { formData, updateFormData } = useFormContext();

    const [loading, setLoading] = useState(false);

    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    const [isDisabled, setIsDisabled] = useState(false);


    useEffect(() => {
        setTimeout(() => setIsButtonDisabled(false), 30000);
    }, []);



    const handleInputChange = (e, index) => {
        const { value } = e.target;
        // Ensure the input is numeric and has a maximum length of 1
        if (/^[0-9]*$/.test(value) && value.length <= 1) {
          const updatedOtp = [...otp];
          updatedOtp[index] = value;
          setOtp(updatedOtp);

        // Check if the current input field is empty and focus on the previous one
            if (value === '' && index > 0) {
                document.getElementById(`otp-input-${index - 1}`).focus();
            } else if (value !== '' && index < 5) {
                document.getElementById(`otp-input-${index + 1}`).focus();
            }

          
        }
      };

    const handlePaste = (e) => {
        e.preventDefault();
        const clipboardData = e.clipboardData.getData('text');
        // Extract and validate the OTP from the clipboard data
        const otpFromClipboard = clipboardData.slice(0, 6).replace(/[^0-9]/g, '');
    
        // Split and assign OTP to individual input fields
        const updatedOtp = Array.from(otpFromClipboard).slice(0, 6);
        setOtp(updatedOtp);
    
        // Focus on the first input field
        document.getElementById('otp-input-0').focus();
      };


    const OtpVerify  = authQueries.useOtpVerifyMutation(

        (response) => {
    
        //   console.log(response?.response?.data?.message)

    
            if(response?.message === "Token verified successfully.") {
    
                // navigation.navigate('callback')

                setLoading(false)

                setIsDisabled(false)

                setNavTab(navTab + 1)
                        
                setOtp(['', '', '', '', '', ''])

                return 
        
                // firstInput.current.focus();/
        
            }


            if(response?.response?.data?.message === "Invalid Token Provided.")  {


                setOtp(['', '', '', '', '', ''])
        
                alert("Invalid OTP")
                
                // firstInput.current.focus();

                setLoading(false)

                setIsDisabled(false)
        
            }

            if(response?.response?.data?.message === "Token or email not provided.")  {

                setOtp(['', '', '', '', '', ''])
        
                alert("Token or email not provided.")
                
                // firstInput.current.focus();

                setLoading(false)

                setIsDisabled(false)
        
            }

            
    
        }
        
      );

    const onSubmit = (data) =>{

        const otpBlank = otp.find((item) => item === "") 

        console.log(otpBlank)

            if (otpBlank === '') {

            alert("Please enter OTP")

            setLoading(false)

            setIsDisabled(false)

            return false

        }

        const otpValue = data.join('');

        // console.log(parseInt(otpValue))
        
        setIsDisabled(true)
        setLoading(true)
        const datavalues = {
          email: formData?.email,
          token: parseInt(otpValue)
        };
        
        OtpVerify.mutateAsync(datavalues);
      };


      const OtpCheck  = authQueries.useOtpCheckMutation(

        (response) => {
    
          

          setLoading(false)
    
        }
        
      );



      const ResendCode = () =>{

        setIsButtonDisabled(true)

        setLoading(true)

        setTimeout(() => setIsButtonDisabled(false), 30000);

        const datavalues = {
          email: formData?.email,
        };
        OtpCheck.mutateAsync(datavalues);



      };

    


    const firstInput = useRef();
    const secondInput = useRef();
    const thirdInput = useRef();
    const fourthInput = useRef();
    const fifthInput = useRef();
    const sixthInput = useRef();



  return (

    <div>

        <div className="tab-pane verification-wrpr" id="step6" role="tabpanel" aria-labelledby="nav-step6-tab">
                                
            <div className="main-hding"><strong>Verify Code</strong></div>
                                
            <div className="row">
                                
                <div className="col text-center mb-3">
                                    
                    <label>Please enter the verification code sent to your email</label>
                                
                </div>
                            
            </div>

            <div className='row' >

            {
                otp.map((digit, index) => (
                    
                        <div className='col' key={index}>
                          
                            <input
                                id={`otp-input-${index}`}
                                type="text"
                                className="form-control text-center" 
                                maxLength={1}
                                value={digit}
                                onChange={(e) => {
                                    handleInputChange(e, index)
                                }}
                                onPaste={handlePaste}
                            />
                        </div>
                    
                )
            )}


            </div>

            <div className="row">
                                
                <div className="col">
                                    
                    {/* <input 
                        maxLength={1}
                        type="number" 
                        ref={firstInput}
                        className="form-control text-center" 
                        onChange={(e) => {
                            // setOtps({ ...otps, one: text.target.value });
                            handleInputChange(e, index)
                            e && secondInput.current.focus()
                        }}
                        onPaste={handlePaste}
                    /> */}
      
                </div>
                                
                {/* <div className="col">
                                        
                    <input 
                        maxLength={1} 
                        type="number"
                        ref={secondInput} 
                        className="form-control text-center" 
                        onChange={(e) => {
                            // setOtps({ ...otps, two: text.target.value });
                            handleInputChange(e, index)
                            e ? thirdInput.current.focus() : firstInput.current.focus() 
                        }} 
                        onPaste={handlePaste}
                    />
                                    
                </div>
                                    
                <div className="col">
                                        
                    <input 
                        ref={thirdInput} 
                        maxLength={1} 
                        type="number" 
                        onPaste={handlePaste}
                        className="form-control text-center"
                        onChange={(e) => {
                            // setOtps({ ...otps, three: text.target.value });
                            handleInputChange(e, index)
                            e ? fourthInput.current.focus() : secondInput.current.focus()
                        }} 
                    />
                                    
                </div>
                                
                <div className="col">
                                        
                    <input 
                        ref={fourthInput} 
                        maxLength={1} 
                        type="number"
                        onPaste={handlePaste}
                        className="form-control text-center" 
                        onChange={(e) => {
                            // setOtps({ ...otps, four: text.target.value });
                            handleInputChange(e, index)
                            e ? fifthInput.current.focus() : thirdInput.current.focus() 
                        }} 
                    />
                                    
                </div>
                                    
                <div className="col">
                                        
                    <input 
                        ref={fifthInput} 
                        onPaste={handlePaste}
                        maxLength={1} 
                        type="number" 
                        className="form-control text-center"
                        onChange={(e) => {
                            // setOtps({ ...otps, five: text.target.value });
                            handleInputChange(e, index)
                            e ? sixthInput.current.focus() : fourthInput.current.focus()
                        }}
                    />
                                    
                </div>

                <div className="col">
                                        
                    <input 
                        ref={sixthInput} 
                        maxLength={1} 
                        onPaste={handlePaste}
                        type="number"
                        className="form-control text-center"
                        onChange={(e) => {
                            setOtps({ ...otps, six: e.target.value });
                            !e && fifthInput.current.focus();
                        }} 
                    />
                                    
                </div> */}
        
            </div>
                            
            <div className="row">

                <div className="col mt-5 text-center">

                    <label>Didn’t receive OTP</label>
                    
                    <br/>

                    <Spin spinning={loading} size='large'>

                        <button  
                            style={{
                                color: isButtonDisabled ? "#989494" : '#1677ff', 
                                borderBottomWidth: 1, 
                                backgroundColor: 'transparent',
                                borderTopWidth: 0, 
                                borderLeftWidth: 0, 
                                borderRightWidth: 0, 
                                borderColor: isButtonDisabled ? '#989494' : '#1677ff'
                            }} 
                            disabled={isButtonDisabled} 
                            className='resend' 
                            onClick={() => ResendCode()}
                        >
                            Resend Code
                        </button>

                    </Spin>

                </div>

            </div>
            
            <div className="row">

                <div className="d-grid gap-2 mt-4 mb-4">

                    <button className="btn btn-primary btn-informant btn-informant-submit" type="submit" onClick={() => onSubmit(otp)}>Verify <i className="icon-arrow-right1"></i></button>
                
                </div>

            </div>
        
        </div>

    </div>

  )

}

export default OtpScreen
